var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayPo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 24,
    viewBox: "0 0 89 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2891_354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1267 13.5886H6.94067V18.6705H12.1267V13.5886Z",
    fill: "#A70584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1005 6.69604H6.91455V11.8206H12.1005V6.69604Z",
    fill: "#36B587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.18598 13.5288H0V18.6534H5.18598V13.5288Z",
    fill: "#FAD05B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5807 6.37153C27.5807 9.90747 24.7025 12.7431 20.9945 12.7431H18.1681V18.5851H13.8638V0H20.9859C24.7111 0 27.5807 2.84413 27.5807 6.37153ZM23.285 6.37153C23.285 5.01352 22.3169 3.98007 21.0031 3.98007H18.1768V8.76299H21.0031C22.3169 8.76299 23.285 7.72954 23.285 6.37153Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5855 4.95368V18.585H38.4454V17.3039C37.5378 18.3373 36.1808 18.9693 34.3312 18.9693C30.7183 18.9693 27.7363 15.8348 27.7363 11.7693C27.7363 7.70386 30.7183 4.56934 34.3312 4.56934C36.1808 4.56934 37.5292 5.19282 38.4454 6.23482V4.95368H42.5855ZM38.4454 11.7693C38.4454 9.72805 37.0625 8.44692 35.1609 8.44692C33.2594 8.44692 31.8765 9.72805 31.8765 11.7693C31.8765 13.8106 33.2594 15.1003 35.1609 15.1003C37.0625 15.1003 38.4454 13.8106 38.4454 11.7693Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3079 4.95386L53.6232 18.0898C52.0847 22.3944 49.6473 24.1026 45.8096 23.9147V20.1225C47.7285 20.1225 48.636 19.5247 49.2324 17.8763L43.7871 4.95386H48.3076L51.35 13.2386L53.9344 4.95386H58.3079Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6325 6.37153C73.6325 9.90747 70.7542 12.7431 67.0463 12.7431H64.2199V18.5851H59.9155V0H67.0376C70.7542 0 73.6325 2.84413 73.6325 6.37153ZM69.3367 6.37153C69.3367 5.01352 68.3687 3.98007 67.0549 3.98007H64.2285V8.76299H67.0549C68.3687 8.76299 69.3367 7.72954 69.3367 6.37153Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1768 11.9574C74.1768 8.00296 77.3488 4.94531 81.2988 4.94531C85.2488 4.94531 88.4209 7.99442 88.4209 11.9574C88.4209 15.9204 85.2488 18.9695 81.2988 18.9695C77.3488 18.9695 74.1768 15.9119 74.1768 11.9574ZM84.3845 11.9574C84.3845 10.0699 83.0448 8.82289 81.2902 8.82289C79.5443 8.82289 78.1959 10.0699 78.1959 11.9574C78.1959 13.845 79.5356 15.0919 81.2902 15.0919C83.0448 15.0919 84.3845 13.8364 84.3845 11.9574Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2891_354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88.4211,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayPo);
export default __webpack_public_path__ + "static/media/pay-po.fb4654c43925d578810734593748c4fd.svg";
export { ForwardRef as ReactComponent };